import taskManager from './taskManager'
import reference from './reference'
import administrator from './administrator'

export default [
  ...administrator,
  ...taskManager,
  ...reference,
]
